import { Pencil, Trash2 } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import { useStore } from '../../../../hooks/useStore';
import type { IPerson } from '../../../../models/person/PersonModel';
import styles from '../Persons.module.css';

export type PersonsActionCellProps = {
  row: IPerson;
};

const PersonsActionCell = ({ row }: PersonsActionCellProps) => {
  const { popupStore, personStore, authStore } = useStore();
  const isAdmin = authStore.isAdmin;

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    personStore.setSelectedPersonToEdit(row);
    popupStore.setIsEditPersonOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isAdmin) {
      toast.error('Bu işlem için admin yetkisi gereklidir.');
      return;
    }
    if (row.id) {
      personStore.setPersonToDelete(row);
      popupStore.setIsDeletePersonConfirmationOpen(true);
    }
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button
        onClick={handleDelete}
        className={`${styles.deleteButton} ${!isAdmin ? styles.disabledButton : ''}`}
        title={isAdmin ? 'Sil' : 'Bu işlem için admin yetkisi gereklidir'}
        disabled={!isAdmin}
      >
        <Trash2 size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(PersonsActionCell);
